import { render } from "./App.vue?vue&type=template&id=6464618b"
import script from "./app-component.ts?vue&type=script&lang=js&external"
export * from "./app-component.ts?vue&type=script&lang=js&external"

import "./App.vue?vue&type=style&index=0&id=6464618b&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__